/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEveHelpData } from './eve-help.data';
import { IEveHelpProps } from './eve-help.props.autogenerated';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';

export interface IEveHelpViewProps extends IEveHelpProps<IEveHelpData> {
    modalBody: React.ReactNode;
    helpButton: React.ReactNode;
    state: IEveHelpState;
}

interface IEveHelpState {
    isModalOpen: boolean;
}

/**
 *
 * EveHelp component
 * @extends {React.PureComponent<IEveHelpProps<IEveHelpData>>}
 */
class EveHelp extends React.PureComponent<IEveHelpProps<IEveHelpData>, IEveHelpState> {
    private _className = 'eve-help';
    constructor(props: IEveHelpProps<IEveHelpData>) {
        super(props);

        this.state = { isModalOpen: false };

        this.toggleModal = this.toggleModal.bind(this);
        this._renderModal = this._renderModal.bind(this);
    }
    private _renderHelpButton() {
        return (
            <button onClick={this.toggleModal} className='help-button'>
                Help
            </button>
        );
    }

    private _renderCloseButton = () => (
        <button className='eve-help__modal-button' onClick={this.toggleModal}>
            Close
        </button>
    );
    private _renderModal = () => {
        return (
            <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                <ModalHeader className={`${this._className}__modal-header`}>{this.props.config.titleText}</ModalHeader>
                {this.state.isModalOpen ? <ModalBody>{this.props.slots.videoPlayer}</ModalBody> : <></>}
                <ModalFooter>{this._renderCloseButton()}</ModalFooter>
            </Modal>
        );
    };

    private toggleModal() {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    }
    public render(): JSX.Element | null {
        const props: IEveHelpViewProps = {
            ...this.props,
            helpButton: this._renderHelpButton(),
            modalBody: this._renderModal(),
            state: this.state
        };
        return this.props.renderView(props);
    }
}

export default EveHelp;
